import { render, staticRenderFns } from "./StockInout.vue?vue&type=template&id=2df62b51&"
import script from "./StockInout.vue?vue&type=script&lang=ts&"
export * from "./StockInout.vue?vue&type=script&lang=ts&"
import style0 from "./StockInout.vue?vue&type=style&index=0&id=2df62b51&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports